<template>
    <v-card class="pa-0" outlined tile>
        <v-card-text class="pa-0">
            <v-data-table
                    :headers="headers"
                    :items="samples"
                    disable-pagination
                    hide-default-footer
            >
                <template v-slot:item="{item, index}">
                    <tr :class="item.is_editing ? 'orange white--text' : null">
                        <td>
                            <v-list-item @click="$emit('edit_sample', item)">
                                <v-list-item-content>
                                    <v-list-item-title>{{item.qa}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </td>
                        <td>{{item.lot}}</td>
                        <td>{{item.name}}</td>
                        <td>
                            {{item.tests.map(test => test.type).join(',')}}
                        </td>
                        <td>
                            <v-btn @click="$emit('remove_sample', index)" color="error" icon><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                        </td>
                    </tr>
                </template>

            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="$emit('save')" large>submit order</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: "CreateOrderTable",
        data: () => ({
           headers: [
               {
                   text: "QA",
                   value: "qa"
               },
               {
                   text: "Lot",
                   value: "lot"
               },
               {
                   text: "Strain",
                   value: "name"
               },
               {
                   text: "Tests",
                   value: "tests"
               },
               {
                   text: "Remove",
                   value: "remove_sample"
               }
           ]
        }),
        props:{
            samples: {
                required: true,
            }
        }
    }
</script>

<style scoped>

</style>
